
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info, RefreshCw, Mail } from 'lucide-react';

interface TestEmailDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  testEmailAddress: string;
  onTestEmailAddressChange: (value: string) => void;
  onSendTestEmail: () => void;
  loadingAction: boolean;
}

export function TestEmailDialog({
  open,
  onOpenChange,
  testEmailAddress,
  onTestEmailAddressChange,
  onSendTestEmail,
  loadingAction
}: TestEmailDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send Test Email</DialogTitle>
          <DialogDescription>
            Send a test email to verify the template rendering and delivery.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="test-email">Recipient Email</Label>
            <Input 
              id="test-email"
              placeholder="Enter email address"
              value={testEmailAddress}
              onChange={(e) => onTestEmailAddressChange(e.target.value)}
            />
          </div>
          
          <Alert variant="default" className="bg-yellow-50 border-yellow-200">
            <Info className="h-4 w-4 text-yellow-600" />
            <AlertTitle className="text-yellow-800">About Test Emails</AlertTitle>
            <AlertDescription className="text-yellow-700">
              Test emails use placeholder data for variables. The subject will include a [TEST] prefix.
            </AlertDescription>
          </Alert>
        </div>
        
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button 
            onClick={onSendTestEmail} 
            disabled={loadingAction || !testEmailAddress}
            className="flex items-center gap-2"
          >
            {loadingAction ? (
              <>
                <RefreshCw className="h-4 w-4 animate-spin" />
                Sending...
              </>
            ) : (
              <>
                <Mail className="h-4 w-4" />
                Send Test Email
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
